<template>
  <div style=" width: 1200px; margin: 0 auto; background-color: #F2F6FC;  ">
<!--    <Title :title="route"></Title>-->
    <Setp :nodes="nodes" :audits="audits"></Setp>

    <el-card class="box-card" style="min-height: 650px;margin-top: 15px" shadow="never">
      <el-form label-position="left" label-width="150px">
        <el-divider content-position="left">项目信息</el-divider>
        <el-form-item label="所属项目" prop="projectName">
          <el-input v-model="detail.projectName" readonly></el-input>
        </el-form-item>
        <el-form-item label="项目合同" prop="contractName">
          <div style="display: flex; align-items: center;">
            <span>{{ detail.contractName }}</span>
            <el-link
                style="margin-left: 8px;"
                type="primary"
                @click="viewContract(detail.contractId)"
            >
              查看
            </el-link>
          </div>
        </el-form-item>

        <el-divider content-position="left">收款方信息</el-divider>
        <el-form-item label="收款单位名称" prop="paymentCompanyName">
          <el-input v-model="detail.paymentCompanyName" readonly></el-input>
        </el-form-item>

        <el-form-item label="收款单位地址" prop="paymentCompanyAddress">
          <el-input type="textarea" rows=3 v-model="detail.paymentCompanyAddress" readonly></el-input>
        </el-form-item>

        <el-form-item label="收款单位电话" prop="paymentCompanyPhone">
          <el-input v-model="detail.paymentCompanyPhone" readonly></el-input>
        </el-form-item>

        <el-form-item label="开户行名称" prop="paymentCompanyBankName">
          <el-input v-model="detail.paymentCompanyBankName" readonly></el-input>
        </el-form-item>

        <el-form-item label="账号" prop="paymentCompanyBankAccountNum">
          <el-input v-model="detail.paymentCompanyBankAccountNum" readonly></el-input>
        </el-form-item>

        <el-divider content-position="left">付款信息</el-divider>
        <el-form-item label="付款单位" prop="paymentCompany">
          <el-radio-group v-model="detail.paymentCompany" style="cursor: not-allowed;pointer-events:none">
            <el-radio label="1">湖南御码</el-radio>
            <el-radio label="2">衡阳御码</el-radio>
            <el-radio label="3">中科安永</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="付款方式" prop="paymentMode">
          <el-radio-group v-model="detail.paymentMode" style="cursor: not-allowed;pointer-events:none">
            <el-radio label="1">转账</el-radio>
            <el-radio label="2">单笔代扣</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="付款性质" prop="paymentNature">
          <el-radio-group v-model="detail.paymentNature" style="cursor: not-allowed;pointer-events:none">
            <el-radio label="1">预付款</el-radio>
            <el-radio label="2">进度款</el-radio>
            <el-radio label="3">结算款</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="付款金额" prop="paymentMoney">
          <el-input :value="Number(detail.paymentMoney).toFixed(2)" readonly>
            <template slot="append">{{ paymentUpperMap.paymentMoney }}</template>
          </el-input>
        </el-form-item>

        <el-divider content-position="left">合同信息</el-divider>
        <el-form-item label="合同总额" prop="contractTotalAmount">
          <el-input :value="Number(detail.contractTotalAmount).toFixed(2)" readonly>
            <template slot="append">{{ paymentUpperMap.contractTotalAmount }}</template>
          </el-input>
        </el-form-item>

        <el-form-item label="已付金额" prop="contractTotalAmount">
          <el-input :value="Number(detail.contractPaidAmount).toFixed(2)" readonly>
            <template slot="append">{{ paymentUpperMap.contractPaidAmount }}</template>
          </el-input>
        </el-form-item>

        <el-form-item label="质保金" prop="qualityRetentionMoney">
          <el-input :value="Number(detail.qualityRetentionMoney).toFixed(2)" readonly>
            <template slot="append">{{ paymentUpperMap.qualityRetentionMoney }}</template>
          </el-input>
        </el-form-item>

        <el-divider content-position="left">发票信息</el-divider>
        <el-form-item label="是否有发票" prop="hasInvoice">
          <el-radio-group v-model="detail.hasInvoice" style="cursor: not-allowed;pointer-events:none">
            <el-radio label="1">有发票</el-radio>
            <el-radio label="2">无发票</el-radio>
          </el-radio-group>
        </el-form-item>

        <div v-if="detail.hasInvoice === '1'">
          <el-form-item label="发票类型" prop="invoiceType">
            <el-radio-group v-model="detail.invoiceType" style="cursor: not-allowed;pointer-events:none">
              <el-radio label="1">普票</el-radio>
              <el-radio label="2">专票</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>

        <el-form-item label="其他附件">
          <div v-if="attachFilePaths && attachFilePaths.length">
            <div v-for="(file, index) in attachFilePaths" :key="index" style="margin-bottom: 4px;">
              <el-link type="primary" @click="download(file)">{{ attachFileNames[index] }}</el-link>
              <el-link
                  v-if="isPdf(file)"
                  style="margin-left: 8px"
                  type="primary"
                  @click="viewPdf(file)"
              >
                预览
              </el-link>
            </div>
          </div>
        </el-form-item>

        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" rows=5 v-model="detail.remark" readonly></el-input>
        </el-form-item>

        <!--    -->
        <AuditList :audits="audits" :auditHistory="auditHistory"></AuditList>


        <div v-if="allowAudit==true">
          <el-divider content-position="left">我要审批</el-divider>


          <el-form-item label="审批意见" prop="remarks">
            <el-input type="textarea" rows="5" maxlength="500" show-word-limit
                      v-model="ruleForm.auditOpinion"></el-input>
          </el-form-item>


          <el-Form-item>
            <el-button type="primary" @click="audit(2)">审核通过</el-button>
            <el-button type="danger" @click="audit(3)">审核拒绝</el-button>
          </el-Form-item>
        </div>
      </el-form>
    </el-card>
    <el-dialog :visible.sync="showPdf" :append-to-body="true" top="0" custom-class="pdf-viewer">
      <div style="width: 100%; height: 100%">
        <iframe
            id="myIframe"
            :src="pdfUrl"
            width="100%"
            height="900px"
        ></iframe>
      </div>
    </el-dialog>

    <el-dialog
        title="合同信息"
        :visible.sync="showInfo"
        width="1200px"
        custom-class="custom-dialog"
        style=" margin: 0 14px 50px 0 !important;"
        :modal="false"
    >
      <ContractDialog style="padding: 20px" :contract-id="detail.contractId" :key="uuid"></ContractDialog>
    </el-dialog>
  </div>


</template>

<script>
import Title from "../../Title";
import {requestApplyDetail, requestAudit, requestAuditShow} from "@/api";
import AuditList from "../common/AuditList";
import Setp from "../common/Setp";
import ContractDialog from "@/components/item/common/ContractDialog.vue";
import {digitUppercase, IsPdf, minioServer, uuid} from "@/util";
import ProjectDialog from "@/components/item/common/ProjectDialog.vue";

export default {
  components: {ProjectDialog, ContractDialog, AuditList, Title, Setp},
  name: "PaymentDetail",
  props: {
    // 接收父组件传入的参数
    query: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      uuid: "",
      showInfo: false,
      showPdf: false,
      pdfUrl: "",
      attachFilePaths: [],
      attachFileNames: [],
      route: {
        name: '付款申请详情',
        path: ''
      },
      detail: {},
      audits: [],
      auditHistory: [],
      applyId: "",
      applyServiceId: "",
      applyType: "",
      ruleForm: {
        auditOpinion: "",
      },
      user: {},
      nodes: [],
      allowAudit: false,
    }
  },
  computed: {
    paymentUpperMap() {
      return {
        paymentMoney: digitUppercase(this.detail.paymentMoney),
        contractTotalAmount: digitUppercase(this.detail.contractTotalAmount),
        contractPaidAmount: digitUppercase(this.detail.contractPaidAmount),
        qualityRetentionMoney: digitUppercase(this.detail.qualityRetentionMoney)
      }
    }
  },
  created() {
    // this.route.path = this.$route.fullPath
    this.applyId = this.query.applyId
    this.applyServiceId = this.query.applyServiceId
    this.applyType = this.query.applyType
    this.getObject()
    this.getAuditShow()
  },
  methods: {
    getAuditShow() {
      requestAuditShow({
        applyId: this.applyId,
      }).then(res => {
        if (res.code == 200) {
          if (res.object) {
            if (res.object == 1) {
              this.allowAudit = true
            }
            if (res.object == 2) {
              this.allowAudit = false
            }
          }
        }
      })
    },
    audit(isAgree) {

      this.allowAudit = false

      if (isAgree == 2 && !this.ruleForm.auditOpinion) {
        this.ruleForm.auditOpinion = "同意"
      }
      if (isAgree == 3 && !this.ruleForm.auditOpinion) {
        this.ruleForm.auditOpinion = "不同意"
      }
      requestAudit({
        isAgree: isAgree,
        applyId: this.applyId,
        applyType: this.applyType,
        auditOpinion: this.ruleForm.auditOpinion,
      }).then(res => {
        if (res.code == 200) {
          this.getAuditShow()
          this.getObject()
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    getObject() {
      requestApplyDetail({
        applyId: this.applyId,
        applyServiceId: this.applyServiceId,
        applyType: this.applyType
      }).then(res => {
        if (res.code == 200) {
          if (res.object) {
            this.detail = res.object.detail

            if (this.detail.paymentCompany) {
              this.detail.paymentCompany = this.detail.paymentCompany + ""
            }
            if (this.detail.moneyType) {
              this.detail.moneyType = this.detail.moneyType + ""
            }
            if (this.detail.hasInvoice) {
              this.detail.hasInvoice = this.detail.hasInvoice + ""
            }
            if (this.detail.paymentMode) {
              this.detail.paymentMode = this.detail.paymentMode + ""
            }
            if (this.detail.invoiceType) {
              this.detail.invoiceType = this.detail.invoiceType + ""
            }
            this.audits = res.object.audits
            this.auditHistory = res.object.auditHistory
            this.user = res.object.user
            this.nodes = res.object.nodes
            this.attachFilePaths = this.detail.invoiceFilePath.split(',')
            this.attachFileNames = this.detail.invoiceFileName.split(',')
          }
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    viewContract(contractId) {
      this.contractId = contractId
      this.showInfo = true
      this.uuid = uuid()
    },
    download(file) {
      window.open(minioServer + file)
    },
    isPdf(file) {
      return IsPdf(file)
    },
    viewPdf(path) {
      this.showPdf = true
      this.pdfUrl = "/pdfjs/web/viewer.html?file=" + minioServer + path
    }
  }
}
</script>

<style>
::v-deep .custom-dialog .el-dialog {
  padding: 20px !important;
}
</style>




